// Utils
import { getEnvironmentApiUrl } from "../services/General";

// Hooks
import { useCallback, useEffect, useState } from "react";
import useHttp from "./useHttp";

// Models
import { IResidence } from "../interfaces/Residence";
import { UserData } from "../interfaces/UserInfo";
import { isResidenceFeatureEnabled } from "../services/residences";

const useResidences = () => {

    const { sendRequest: getResidences } = useHttp<IResidence[]>();
    const [residences, setResidences] = useState<IResidence[]>([]);

    const { sendRequest: assignUser } = useHttp();

    useEffect(() => {
        if (!isResidenceFeatureEnabled()) return;
        getResidences({
            url: getEnvironmentApiUrl() + 'residence/all',
            method: 'POST',
            body: { params: {}, filter: {} }
        }, (data) => {
            setResidences(data);
        })
    }, [getResidences]);

    const linkUser = useCallback((user: UserData, residenceID: number | string) => {
        if (!isResidenceFeatureEnabled()) return;
        const isUserAssigned = residences.some(r => (r.id === residenceID && r.users?.some(u => u.id === user.id)));
        assignUser({
            url: getEnvironmentApiUrl() + `residence/${isUserAssigned ? 'un' : ''}assign_user`,
            method: 'POST',
            body: {
                user_id: user.id,
                residence_id: residenceID
            }
        }, () => {
            setResidences(oldResidences => oldResidences.map(r => {
                if (r.id !== residenceID) return r;
                const users = r.users ?? [];
                return {
                    ...r,
                    users: isUserAssigned ?
                        users.filter(u => u.id !== user.id) : [...users, user]
                }
            }))
        })
    }, [assignUser, residences])


    return { residences, linkUser };

};

export default useResidences;
